var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-desktop" },
    [
      _vm.Config.STANDALONE ? _c("asta-drawer-standalone") : _c("asta-drawer"),
      _vm._v(" "),
      _c("asta-nav"),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-col", { attrs: { cols: "3" } }, [
                _c(
                  "div",
                  { staticClass: "asta-svincolati-desktop" },
                  [_c("asta-svincolati", { attrs: { showTitle: "" } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "desktop-central", attrs: { cols: "6" } },
                [
                  _c(
                    "div",
                    { staticClass: "asta-tavolo-desktop" },
                    [_c("asta-tavolo")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "asta-chat-messages-desktop" },
                    [_c("asta-chat-messages")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "asta-chat-input-desktop" },
                    [_c("asta-chat-input")],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "3" } }, [
                _c(
                  "div",
                  { staticClass: "asta-rose-desktop" },
                  [
                    _c("asta-rose", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.planOrRose == "rose",
                          expression: "(planOrRose == 'rose')",
                        },
                      ],
                      attrs: { showTitle: "" },
                    }),
                    _vm._v(" "),
                    _vm.my_squadra
                      ? _c("asta-plan", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.planOrRose == "plan",
                              expression: "(planOrRose == 'plan')",
                            },
                          ],
                          attrs: { showTitle: "" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("asta-footer", { attrs: { fixed: "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }